module.exports = __webpack_public_path__ + "img/card-bg-03.6d08d60c.png";